/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beweegactiviteitenreeks_Api_Errors_Update_Not_AllowedInputs */

const nl_beweegactiviteitenreeks_api_errors_update_not_allowed = /** @type {(inputs: Beweegactiviteitenreeks_Api_Errors_Update_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt geen toestemming om deze beweegactiviteit te wijzigen`)
};

/**

* @param {Beweegactiviteitenreeks_Api_Errors_Update_Not_AllowedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const beweegactiviteitenreeks_api_errors_update_not_allowed = /** @type {((inputs?: Beweegactiviteitenreeks_Api_Errors_Update_Not_AllowedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beweegactiviteitenreeks_Api_Errors_Update_Not_AllowedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_beweegactiviteitenreeks_api_errors_update_not_allowed(inputs)
});
export { beweegactiviteitenreeks_api_errors_update_not_allowed as "beweegactiviteitenreeks.api_errors.update_not_allowed" }